import Blue from '~/core';

new Blue({
	name: 'mobile filters',
	selector: '.filters',
	setup(filters) {
    if (filters.closest('#search-app')) return 
		const triggers = [...filters.querySelectorAll('.filters__close, .filters__toggle')];
		const inner = filters.querySelector('.filters__inner');
		const content = filters.querySelector('.filters__content');
    const activeClass = 'filters--active';
    const groups = [...filters.querySelectorAll('.filters__group')]

		let isOpen = () => filters.classList.contains(activeClass);

		const toggle = (e) => {
			if (isOpen()) {
        filters.classList.remove(activeClass)
        this.$scrollLock.unlock(content)
      }
      else {
        filters.classList.add(activeClass)
        this.$scrollLock.lock(content)
      }
    };
    
    groups.forEach(group => {
      const trigger = group.querySelector('.filters__title');
      const content = group.querySelector('.filters__options');
      let config = {
        trigger,
        content,
        props: ['height']
      }
      const accordion = new this.$toggle(config)
      accordion.toggle(trigger)
    })

		this.$addEvents(triggers, 'click.prevent enter.prevent', toggle);
		this.$addEvents(inner, 'click.self', toggle);
	},
});